import { ThemeProvider } from '@icims-design-system/mui-core';
import { CircularProgress } from '@mui/material';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { Suspense, useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { I18nextProvider } from 'react-i18next';
import { RouterProvider, createBrowserRouter } from 'react-router';

import { AlertProvider } from './context/AlertContext';
import { ExternalSubmissionProvider } from './context/ExternalSubmissionContext';
import { i18n } from './i18n';
import { routesConfig } from './routesConfig';
import { initPendo, pendoScript } from './util/pendo';
import api from './util/pendoApi';

const queryClient = new QueryClient();

const router = createBrowserRouter(routesConfig);

const App = () => {
	useEffect(() => {
		pendoScript();
		api
			.getUserData()
			.then((res) => initPendo(res.data))
			// eslint-disable-next-line no-console
			.catch((err) => console.log('Pendo initialization failed', { err }));
	}, []);

	return (
		<QueryClientProvider client={queryClient}>
			<I18nextProvider i18n={i18n}>
				<ThemeProvider variant="light">
					<Suspense fallback={<CircularProgress />}>
						<DndProvider backend={HTML5Backend}>
							<AlertProvider>
								<ExternalSubmissionProvider>
									<RouterProvider router={router} />
								</ExternalSubmissionProvider>
							</AlertProvider>
						</DndProvider>
					</Suspense>
				</ThemeProvider>
			</I18nextProvider>
			<ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
		</QueryClientProvider>
	);
};

export default App;
